module.exports = __webpack_public_path__ + "img/marker_five_yellow1.3e21c82c.png";